import clsx from "clsx";
import { AnchorHTMLAttributes, FC } from "react";
import { Link as RouterLink } from "react-router-dom";

interface LinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "onClick"> {
  onClick?: Function;
  useTheme?: boolean;
  userouter?: boolean;
  // Router location state, only used when `userouter` is set
  state?: unknown;
}

export const Link: FC<LinkProps> = ({
  children,
  className,
  href,
  onClick,
  useTheme,
  userouter,
  state,
  ...props
}) => {
  //TODO - refactor to handle stop propagation on the oustide of this component (about 7 or so files to change)
  const handleClick = (e: React.MouseEvent): void => {
    if (onClick) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      onClick();
    }
  };

  if (userouter)
    return (
      <RouterLink
        className={className}
        onClick={handleClick}
        to={href || ""}
        state={state}
        {...props}
      >
        {children}
      </RouterLink>
    );

  return (
    <a
      className={clsx(["ddbc-link", useTheme && "ddbc-theme-link", className])}
      onClick={handleClick}
      href={href}
      {...props}
    >
      {children}
    </a>
  );
};
